import React from "react";
import FilterSelect from "../Filter/FilterSelect";
import "./Reports.scss";

// const options = [
//   { value: "all", label: "All" },
//   { value: "custom_report", label: "Custom Report" },
//   { value: "author_affiliation_report", label: "Author Affiliation Report" },
//   {
//     value: "open_access_publisher_yes",
//     label: "Open Access On Publisher Site Yes",
//   },
//   {
//     value: "open_access_publisher_unknown",
//     label: "Open Access On Publisher Site Unknown",
//   },
//   { value: "reuse_terms_yes", label: "Reuse Terms Available Yes" },
//   { value: "reuse_terms_unknown", label: "Reuse Terms Available Unknown" },
//   { value: "archive_yes", label: "Archive Yes" },
//   { value: "archive_unknown", label: "Archive Unknown" },
//   { value: "dataset", label: "Dataset" },
// ];

const ReportTypeSelector = ({ value, onChange, options }) => {
  return (
    <div className="report-type-selector">
      <label className="field-label">Select Report Type</label>

      <div className="report-type-container ">
        <FilterSelect
          label=""
          value={value?.label} //|| options[0].label
          options={options}
          onChange={(value) => onChange(value)}
          // width="50%"
          width="full"
        />
      </div>

      {value?.value === "all" && (
        <p className="text-dark mt-4">
          Selecting “All” will generate a report that includes all fields.
        </p>
      )}

      {value?.value === "customReport" && (
        <p className="text-dark mt-4">
          You can generate a custom report tailored to your specific data needs
          including selected fields, filters and time ranges.
        </p>
      )}
    </div>
  );
};

export default ReportTypeSelector;
